<ng-container>
  <header  class="header-second">
    <div class="blue-angled-bg">
      <div
        class="app-header bolt-container-fluid wrapper-container page-wrapper-lg"
        >
        <div class="header">
          <div
            class="bolt-row bolt-justify-content-between bolt-align-items-center bolt-space-bottom-md"
            >
            <div class="bolt-col-4 logo-container">
              <bolt-logo></bolt-logo>
            </div>
            <div class="user-profile-container">
              @if (shouldShowProfileComponent$ | async) {
                <nwx-profile-menu
                  [userName]="(this.userName$ | async) || ''"
                  [agentCenterUrl]="agentCenterUrl"
                  [producerCode]="(this.producerCode$ | async) || ''"
                  [producerName]="(this.agentName$ | async) || ''"
                  [maxSizeXSmall]="maxSizeXSmall$ | async"
                ></nwx-profile-menu>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</ng-container>
